'use strict';
var $ = require('../internals/export');
var $toArray = require('../internals/async-iterator-iteration').toArray;

// `AsyncIterator.prototype.toArray` method
// https://github.com/tc39/proposal-async-iterator-helpers
$({ target: 'AsyncIterator', proto: true, real: true }, {
  toArray: function toArray() {
    return $toArray(this, undefined, []);
  }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/modules/esnext.async-iterator.to-array.js
// module id = 1062
// module chunks = 29